import * as React from 'react';
import { useState,useEffect } from 'react';
import { Link,useSearchParams } from 'react-router-dom';
import axios from 'axios';
import "./userProfile.css";
import  ProfileImage  from './hamza.jpeg';
import  facebook  from './face-n-1.svg';
import  whatsApp  from './whatsapp-n-1.svg';
import  phone  from './phone-n-1.svg';
import  Twiter  from './x-n-1.svg';
import  Linkedin  from './linkedin-n-1.svg';
import  Telegram  from './Telegram22.svg';
import  Instagram  from './instaLastV.svg';
import  snap  from './snap-n-1.svg';
import  tiktok  from './tiktok-n-1.svg';
import  youtube  from './youTube-n-1.svg';
import  link  from './whebsiteLastV.svg';
import  Email  from './emailLastV.svg';
import  Pdf  from './pdf.svg';
import  Location  from './location-n.svg';
import  telegram  from './telegram-n.svg';
import  Pintrest  from './pintrest.svg';
import  RadiousImage  from './image-with-color.svg';
import  company  from './company.svg';
import  link2  from './link-svgrepo-com.svg';
import  WeChat  from './wechat.svg';
import  Stars  from './starOne.svg';
import  GoogleRate  from './google-svgrepo-com.svg';
import RestaurantMenu from '@mui/icons-material/RestaurantMenu';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailIcon from '@mui/icons-material/Email';
import LanguageIcon from '@mui/icons-material/Language';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CallIcon from '@mui/icons-material/Call';
import LinkIcon from '@mui/icons-material/Link';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import PinterestIcon from '@mui/icons-material/Pinterest';
import TelegramIcon from '@mui/icons-material/Telegram';
import TwitterIcon from '@mui/icons-material/Twitter';
import YouTubeIcon from '@mui/icons-material/YouTube';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DownloadIcon from '@mui/icons-material/Download';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import StarIcon from '@mui/icons-material/Star';

import SaveContac from "./saveContact";
import MuiImageSlider from "mui-image-slider";
import { Helmet, HelmetProvider } from 'react-helmet-async'; 
import UseSEO from '../Hoks';

function UserProfile(props) {
  const [data ,setData]=useState({})
  const [loading ,setLoading]=useState(0)
  const[searchParams] = useSearchParams()
  const[id,setId] = useState('')
  const[color,setColor] = useState('')
  const [linkModal, setLinkModal] = useState(null)
  const [selectedLinkIndex, setSelectedLinkIndex] = useState(0)
  const [pdfSizes, setPdfSizes] = useState({})

  const formatFileSize = (bytes) => {
    if (!bytes) return ''
    const mb = bytes / (1024 * 1024)
    return mb >= 1 ? `${mb.toFixed(1)} MB` : `${Math.max(1, Math.round(bytes / 1024))} KB`
  }

  const getYoutubeEmbedUrl = (url) => {
    if (!url) return ''
    const match = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{6,})/)
    return match ? `https://www.youtube.com/embed/${match[1]}` : url
  }

  useEffect(() => {
    if (!data.pdf?.length) return
    data.pdf.forEach((item, index) => {
      if (!item.link) return
      axios.head(item.link)
        .then((res) => {
          const bytes = parseInt(res.headers['content-length'], 10)
          if (bytes) {
            setPdfSizes(prev => ({ ...prev, [index]: formatFileSize(bytes) }))
          }
        })
        .catch(() => {})
    })
  }, [data.pdf])

  const quickActionTypes = {
    WhatsApp: {
      hrefBuilder: (value) => `https://wa.me/${value}`,
      icon: (size) => <WhatsAppIcon sx={{ fontSize: size, color: color }} />,
    },
    Email: {
      hrefBuilder: (value) => `mailto:${value}`,
      icon: (size) => <EmailIcon sx={{ fontSize: size, color: color }} />,
    },
    Call: {
      hrefBuilder: (value) => `tel:${value}`,
      icon: (size) => <CallIcon sx={{ fontSize: size, color: color }} />,
    },
    Website: {
      hrefBuilder: (value) => value,
      icon: (size) => <LanguageIcon sx={{ fontSize: size, color: color }} />,
    },
    Location: {
      hrefBuilder: (value) => value,
      icon: (size) => <LocationOnIcon sx={{ fontSize: size, color: color }} />,
    },
    LinkedIn: {
      hrefBuilder: (value) => value,
      icon: (size) => <LinkedInIcon sx={{ fontSize: size, color: color }} />,
    },
    Instagram: {
      hrefBuilder: (value) => value,
      icon: (size) => <InstagramIcon sx={{ fontSize: size, color: color }} />,
    },
    'X (Twitter)': {
      hrefBuilder: (value) => value,
      icon: (size) => (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill={color}>
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
      </svg>),
    },
    YouTube: {
      hrefBuilder: (value) => value,
      icon: (size) => <YouTubeIcon sx={{ fontSize: size, color: color }} />,
    },
    Facebook: {
      hrefBuilder: (value) => value,
      icon: (size) => <FacebookIcon sx={{ fontSize: size, color: color }} />,
    },
    TikTok: {
      hrefBuilder: (value) => value,
      icon: (size) =>( <svg
        fill={color}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 50 50"
        width="24"
        height="24"
      >
        <path d="M41,4H9C6.243,4,4,6.243,4,9v32c0,2.757,2.243,5,5,5h32c2.757,0,5-2.243,5-5V9C46,6.243,43.757,4,41,4z M37.006,22.323 c-0.227,0.021-0.457,0.035-0.69,0.035c-2.623,0-4.928-1.349-6.269-3.388c0,5.349,0,11.435,0,11.537c0,4.709-3.818,8.527-8.527,8.527 s-8.527-3.818-8.527-8.527s3.818-8.527,8.527-8.527c0.178,0,0.352,0.016,0.527,0.027v4.202c-0.175-0.021-0.347-0.053-0.527-0.053 c-2.404,0-4.352,1.948-4.352,4.352s1.948,4.352,4.352,4.352s4.527-1.894,4.527-4.298c0-0.095,0.042-19.594,0.042-19.594h4.016 c0.378,3.591,3.277,6.425,6.901,6.685V22.323z" />
      </svg>)
        //  <img src={tiktok} style={{ width: size, height: size }} alt="TikTok" />,
    },
    Snapchat: {
      hrefBuilder: (value) => value,
      icon: (size) => (<svg role="img" width="22" height="22" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill={color} color={color}><path d="M12.206.793c.99 0 4.347.276 5.93 3.821.529 1.193.403 3.219.299 4.847l-.003.06c-.012.18-.022.345-.03.51.075.045.203.09.401.09.3-.016.659-.12 1.033-.301.165-.088.344-.104.464-.104.182 0 .359.029.509.09.45.149.734.479.734.838.015.449-.39.839-1.213 1.168-.089.029-.209.075-.344.119-.45.135-1.139.36-1.333.81-.09.224-.061.524.12.868l.015.015c.06.136 1.526 3.475 4.791 4.014.255.044.435.27.42.509 0 .075-.015.149-.045.225-.24.569-1.273.988-3.146 1.271-.059.091-.12.375-.164.57-.029.179-.074.36-.134.553-.076.271-.27.405-.555.405h-.03c-.135 0-.313-.031-.538-.074-.36-.075-.765-.135-1.273-.135-.3 0-.599.015-.913.074-.6.104-1.123.464-1.723.884-.853.599-1.826 1.288-3.294 1.288-.06 0-.119-.015-.18-.015h-.149c-1.468 0-2.427-.675-3.279-1.288-.599-.42-1.107-.779-1.707-.884-.314-.045-.629-.074-.928-.074-.54 0-.958.089-1.272.149-.211.043-.391.074-.54.074-.374 0-.523-.224-.583-.42-.061-.192-.09-.389-.135-.567-.046-.181-.105-.494-.166-.57-1.918-.222-2.95-.642-3.189-1.226-.031-.063-.052-.15-.055-.225-.015-.243.165-.465.42-.509 3.264-.54 4.73-3.879 4.791-4.02l.016-.029c.18-.345.224-.645.119-.869-.195-.434-.884-.658-1.332-.809-.121-.029-.24-.074-.346-.119-1.107-.435-1.257-.93-1.197-1.273.09-.479.674-.793 1.168-.793.146 0 .27.029.383.074.42.194.789.3 1.104.3.234 0 .384-.06.465-.105l-.046-.569c-.098-1.626-.225-3.651.307-4.837C7.392 1.077 10.739.807 11.727.807l.419-.015h.06z"/></svg>),
    },
    Telegram: {
      hrefBuilder: (value) => value,
      icon: (size) => <TelegramIcon sx={{ fontSize: size, color: color }} />,
    },
    WeChat: {
      hrefBuilder: (value) => value,
      icon: (size) => (<svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        width="22"
        height="22"
        fill={color}
      >
        <path d="M11.176 14.429c-2.665 0-4.826-1.8-4.826-4.018 0-2.22 2.161-4.018 4.826-4.018s4.826 1.798 4.826 4.018c0 1.129-.516 2.17-1.387 2.9-.406.347-1.126 1.006-1.22 1.096-.112.106-.219.193-.298.247-.482.337-1.026.541-1.468.618a3.674 3.674 0 0 1-.453.057zm-8.384-3.52c.038.196.095.39.172.582-.262.13-.532.235-.807.312-.477.135-1.036.216-1.558.261-.177.016-.339-.022-.442-.108-.093-.078-.152-.19-.158-.31-.008-.15.045-.297.147-.406.079-.084.777-.791 1.009-1.055.207-.235.347-.468.428-.682-.962-.835-1.572-1.996-1.572-3.266 0-2.68 2.893-4.851 6.452-4.851 3.483 0 6.305 2.054 6.44 4.673-.131-.013-.263-.021-.397-.021-3.136 0-5.679 2.127-5.679 4.747 0 .584.144 1.141.404 1.649-.126.07-.282.162-.468.277-.384.237-1.055.772-1.168.863z"/>
        <path d="M4.654 4.079c.675 0 1.222.457 1.222 1.02 0 .563-.547 1.02-1.222 1.02-.676 0-1.223-.457-1.223-1.02 0-.563.547-1.02 1.223-1.02zm5.405 0c.675 0 1.222.457 1.222 1.02 0 .563-.547 1.02-1.222 1.02s-1.222-.457-1.222-1.02c0-.563.547-1.02 1.222-1.02z"/>
      </svg>),
    },
    Pinterest: {
      hrefBuilder: (value) => value,
      icon: (size) => <PinterestIcon sx={{ fontSize: size, color: color }} />,
    },
    Link: {
      hrefBuilder: (value) => value,
      icon: (size) => <LinkIcon sx={{ fontSize: size, color: color }} />,
    },
  }

  const socialMediaFields = [
    { label: 'LinkedIn', items: data.linkedin },
    { label: 'Instagram', items: data.instgram },
    { label: 'X (Twitter)', items: data.twiter },
    { label: 'YouTube', items: data.youtube },
    { label: 'Facebook', items: data.facebook },
    { label: 'TikTok', items: data.tikTok },
    { label: 'Snapchat', items: data.snapChat },
    { label: 'Telegram', items: data.telegram },
    { label: 'WeChat', items: data.weChat },
    { label: 'Pinterest', items: data.pintrest },
  ].filter(field => field.items?.length > 0)

  const handleQuickAction = (label, items) => {
    if (!items || items.length === 0) return
    if (items.length === 1) {
      window.open(quickActionTypes[label].hrefBuilder(items[0].link), '_blank', 'noopener,noreferrer')
    } else {
      setSelectedLinkIndex(0)
      setLinkModal({ label, items })
    }
  }

  
  

  function getUseInfo(id1) {
    
    axios.post('/get_Order_by_id', {id:id1})
    .then((result) => {
      console.log('result.data.order',result.data.order);
      setData(result.data.order)
      setColor(result.data.order.color)
      setLoading(1)
      callCEO()
     
    })
    .catch((error) => {
      console.error(error);
    });
    
  }
  useEffect(()=>{
    getIdValue()
  },[])
  async function getIdValue(params) {
    await setId(searchParams.get('id'))
    getUseInfo(searchParams.get('id'))
  }
  const svg = `
    <svg width="393" height="125" xmlns="http://www.w3.org/2000/svg">
      <path d="M-1 0.0539551L3.1 21.385C6.94048 41.3516 17.6167 59.3564 33.2932 72.3047C48.9698 85.2529 68.6675 92.3355 89 92.335H393V126.481H-1V0.0539551Z" fill="${color}"/>
    </svg>
  `;
  
  const encodedSvg = encodeURIComponent(svg).replace(/'/g, '%27').replace(/"/g, '%22');
  const backgroundImage = `url('data:image/svg+xml;charset=UTF-8,${encodedSvg}')`;
function callCEO(params) {
  UseSEO({
    title: `${data.fullName}`,
    description: `${data.department}`,
    image: data.mainUserImg,
    url:window.location.href,
    type: 'profile',
  });
}
    return (
     <>
     { loading &&
     <>
    { data.newDesign ? (
      <>
      {data?.orderEnabled === false || (data?.expiredAt && data?.expiredAt <= new Date().toISOString().split('T')[0]) ? (
      <div className="container width-of-page" style={{border: 'unset'}}>
        <div className="card-expired-message">
          <img
            src={data?.mainUserImg ? data?.mainUserImg : 'https://ccnfctag.com/uploads/1744662353893.jpeg'}
            className="card-expired-message__image"
            alt="Card"
          />
          <p className="card-expired-text">This card is expired. Please contact support.</p>
          <a
            href="https://wa.me/962785444032"
            target="_blank"
            rel="noopener noreferrer"
            className="card-expired-whatsapp-btn"
          >
            <img src={whatsApp} alt="WhatsApp" />
            <span>Contact support on WhatsApp</span>
          </a>
        </div>
      </div>
      ) : (
      <div className="nd-page">
        <div className="nd-header">
          <div className="nd-logo">
            {data.logoImage && <img className="nd-logo-img" src={data.logoImage} alt="logo" /> }
          </div>
         {data?.mainUserImg && <div className="nd-avatar-frame">
            <img className="nd-avatar" src={data?.mainUserImg ? data.mainUserImg : 'https://ccnfctag.com/uploads/1744662353893.jpeg'} alt={data.fullName} />
            {/* <span className="nd-badge">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 13l4 4L19 7" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </span> */}
          </div>}
        </div>
        <div className="nd-body">
          <h1 className="nd-name">{data.fullName}</h1>
          {(data.title || data.department) &&
            <p className="nd-role">{[data.title, data.department].filter(Boolean).join(' • ')}</p>
          }
          {data.company &&
            <p className="nd-bio">{data.company}</p>
          }

          <div className="nd-save-wrap">
            <SaveContac color={color} data={data} />
          </div>

          <div className="nd-grid">
            {data.whatsApp?.length > 0 &&
              <div className="nd-grid-item" onClick={() => handleQuickAction('WhatsApp', data.whatsApp)}>
                <div className="nd-icon-circle">{quickActionTypes.WhatsApp.icon(28)}</div>
                <span className="nd-icon-label">WhatsApp</span>
              </div>
            }
            {data.email?.length > 0 &&
              <div className="nd-grid-item" onClick={() => handleQuickAction('Email', data.email)}>
                <div className="nd-icon-circle">{quickActionTypes.Email.icon(28)}</div>
                <span className="nd-icon-label">Email</span>
              </div>
            }
            {data.mobileNumber?.length > 0 &&
              <div className="nd-grid-item" onClick={() => handleQuickAction('Call', data.mobileNumber)}>
                <div className="nd-icon-circle">{quickActionTypes.Call.icon(28)}</div>
                <span className="nd-icon-label">Call</span>
              </div>
            }
            {data.website?.length > 0 &&
              <div className="nd-grid-item" onClick={() => handleQuickAction('Website', data.website)}>
                <div className="nd-icon-circle">{quickActionTypes.Website.icon(28)}</div>
                <span className="nd-icon-label">Website</span>
              </div>
            }
            {data.location?.length > 0 &&
              <div className="nd-grid-item" onClick={() => handleQuickAction('Location', data.location)}>
                <div className="nd-icon-circle">{quickActionTypes.Location.icon(28)}</div>
                <span className="nd-icon-label">Location</span>
              </div>
            }
            {data.link?.length > 0 &&
              <div className="nd-grid-item" onClick={() => handleQuickAction('Link', data.link)}>
                <div className="nd-icon-circle">{quickActionTypes.Link.icon(28)}</div>
                <span className="nd-icon-label">Services & Links</span>
              </div>
            }
          </div>

          {linkModal &&
            <div className="nd-modal-overlay" onClick={() => setLinkModal(null)}>
              <div className="nd-modal-sheet" onClick={(e) => e.stopPropagation()}>
                <div className="nd-modal-header">
                  {quickActionTypes[linkModal.label].icon(24)}
                  <span className="nd-modal-title">{linkModal.label}</span>
                </div>
                <div className="nd-modal-list">
                  {linkModal.items.map((item, index) => (
                    <a
                      key={`nd-${linkModal.label}-${index}`}
                      className="nd-modal-row"
                      href={quickActionTypes[linkModal.label].hrefBuilder(item.link)}
                      rel="noopener noreferrer"
                      onClick={() => { setSelectedLinkIndex(index); setLinkModal(null); }}
                    >
                      <div className="nd-modal-row-icon">{quickActionTypes[linkModal.label].icon(22)}</div>
                      <div className="nd-modal-row-text">
                        <span className="nd-modal-row-label">{item.type || linkModal.label}</span>
                        <span className="nd-modal-row-number">{item.link}</span>
                      </div>
                      {/* <span className={`nd-modal-radio ${selectedLinkIndex === index ? 'nd-modal-radio-selected' : ''}`} /> */}
                    </a>
                  ))}
                </div>
                <button type="button" className="nd-modal-cancel" onClick={() => setLinkModal(null)}>Cancel</button>
              </div>
            </div>
          }

          {socialMediaFields.length > 0 &&
            <div className="nd-social-section">
              <p className="nd-social-title">Social Media</p>
              <div className="nd-social-grid">
                {socialMediaFields.map((field) => (
                  <div
                    key={`nd-social-${field.label}`}
                    className="nd-social-item"
                    onClick={() => handleQuickAction(field.label, field.items)}
                  >
                    {quickActionTypes[field.label].icon(24)}
                    <span>{field.label}</span>
                  </div>
                ))}
              </div>
            </div>
          }

          {data.pdf?.length > 0 &&
            <div className="nd-file-list">
              {data.pdf.map((item, index) => (
                <a className="nd-file-card" key={`nd-pdf-${index}`} href={item.link} target="_blank" rel="noopener noreferrer">
                  <div className="nd-file-icon" style={{backgroundColor:color}}><PictureAsPdfIcon sx={{ fontSize: 22, color: '#fff' }} /></div>
                  <div className="nd-file-info">
                    <span className="nd-file-name">{item.type || 'Document.pdf'}</span>
                    {pdfSizes[index] && <span className="nd-file-size">{pdfSizes[index]}</span>}
                  </div>
                  {/* <DownloadIcon sx={{ fontSize: 22, color: color }} /> */}
                  <ChevronRightIcon sx={{ fontSize: 24, color: color }} />
                </a>
              ))}
            </div>
          }

          {data.googleRate?.length > 0 &&
            <div className="nd-file-list">
              {data.googleRate.map((item, index) => (
                <a className="nd-review-card" key={`nd-gr-${index}`} href={item.link} rel="noopener noreferrer">
                  <div className="nd-review-icon" style={{backgroundColor:color}}><img src={GoogleRate} alt="Google" /></div>
                  <div className="nd-review-info">
                    <span className="nd-review-title">Google Reviews</span>
                    <div className="nd-review-stars">
                      {[...Array(5)].map((_, i) => <StarIcon sx={{ fontSize: 14, color: '#ffd600'}} /> )}
                    </div>
                    {item.type && <span className="nd-review-caption">{item.type}</span>}
                  </div>
                  <ChevronRightIcon sx={{ fontSize: 24, color: color }} />
                </a>
              ))}
            </div>
          }

          {data.youtubeIframeLink &&
            <div className="nd-youtube-section">
              <div className="nd-youtube-frame-wrap">
                <iframe
                  className="nd-youtube-frame"
                  src={getYoutubeEmbedUrl(data.youtubeIframeLink)}
                  title="YouTube video"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                />
              </div>
            </div>
          }

          {data.qrUserImageUploade &&
            <div className="nd-qr-section">
              {/* <p className="nd-social-title">Scan QR Code</p> */}
              <div className="nd-qr-card">
                <img className="nd-qr-image" src={data.qrUserImageUploade} alt="QR Code" />
              </div>
            </div>
          }

          {data.menuLink &&
            <div className="nd-more-links">
              <a className="nd-link-item" href={data.menuLink} target="_blank" rel="noopener noreferrer">
                <div className="nd-icon-circle"><RestaurantMenu sx={{ fontSize: 26, color: '#3fae52' }} /></div>
                <span>Show Menu</span>
              </a>
            </div>
          }

          {data.orderImages?.length > 0 &&
            <div className="nd-gallery">
              <MuiImageSlider images={data.orderImages} />
            </div>
          }
        </div>
      </div>
      )}
      </>
    ) :
     <>
      {data?.orderEnabled === false ||( data?.expiredAt && data?.expiredAt <= new Date().toISOString().split('T')[0]) ? (
      <>
     
    
      <div className="container width-of-page" style={{border: 'unset'}}>
        <div className="card-expired-message">
          <img
            src={data?.mainUserImg ? data?.mainUserImg :'https://ccnfctag.com/uploads/1744662353893.jpeg'}
            className="card-expired-message__image"
            alt="Card"
          />
          <p className="card-expired-text">This card is expired. Please contact support.</p>
          <a
            href="https://wa.me/962785444032"
            target="_blank"
            rel="noopener noreferrer"
            className="card-expired-whatsapp-btn"
          >
            <img src={whatsApp} alt="WhatsApp" />
            <span>Contact support on WhatsApp</span>
          </a>
        </div>
      </div>
      </>
    ) : (

  <div className="container width-of-page">
     <div className='images-top'>
    <img src={data?.mainUserImg ? data?.mainUserImg :'https://ccnfctag.com/uploads/1744662353893.jpeg'}  className='user-image' alt="react logo" />
    {/* <img className='img-color' src={RadiousImage}  alt="RadiousImage logo" /> */}
     <svg 
  width="100%" 
  height="137" 
  className="img-color" 
  viewBox="0 0 392 137" 
  fill="none" 
  xmlns="http://www.w3.org/2000/svg"
  preserveAspectRatio="none"
>
  <path 
    d="M392 87.3728V137L387.916 115.786C375.763 45.2173 344.18 16.7584 302.457 16.7584H0.00708008V0H305.105C318.722 0.358785 380.926 6.45813 392 87.3728Z" 
    fill={color} 
  />
</svg> 
    {/* <svg className='img-color'  width="100%" height="150" viewBox="0 0 393 125" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M-1 0.0539551L3.1 21.385C6.94048 41.3516 17.6167 59.3564 33.2932 72.3047C48.9698 85.2529 68.6675 92.3355 89 92.335H393V126.481H-1V0.0539551Z" fill={color}/>
</svg> */}
    </div>
    <div className='main-user-info'>
      <div>
    <div className='user-info user-info-new'>
      <div>
      <h1 className='inter'>
      {data.fullName}
      </h1>
      {data.department && <h2>{data.department}</h2>}
      {data.company && <p>{data.company}</p>}
      </div>
      {data.logoImage &&  <img src={data?.logoImage}  className='logo-image' alt="react logo" />}
    </div>
    </div>
    <div className='user-linkes'>
    {data.mobileNumber.length > 0 &&
data.mobileNumber.map((data, index) => (
  <a className='main-image-link' key={index} href={`tel:${data.link}`}  rel="noopener noreferrer">
     <div style={{backgroundColor: color}} className='image-link '>
    <img src={phone} alt="phone logo" />
    </div>
    <span>phone</span>
    <span>{data.type}</span>
  </a>
))
}
{data.whatsApp.length > 0 &&

data.whatsApp.map((data, index) => (
  <a style={{backgroundColor: data.color}} className='main-image-link' key={index} href={`https://wa.me/${data.link}`}  rel="noopener noreferrer">
     <div style={{backgroundColor: color}} className='image-link '>
    <img src={whatsApp} alt="whatsApp logo" />
    </div>
    <span>WhatsApp</span>
    <span>{data.type}</span>
  </a>
))
}
{data.email.length > 0 &&
data.email.map((data, index) => (
  <a className='main-image-link' key={index} href={`mailto:${data.link}`}  rel="noopener noreferrer">
    <div style={{backgroundColor: color}} className='image-link'>
    <img src={Email} alt="Email logo" />
    </div>
    <span>Email</span>
    <span>{data.type}</span>
  </a>
))
}
      {data.facebook.length > 0 &&
      
data.facebook.map((data, index) => (
  <a className='main-image-link' key={index} href={data.link}  rel="noopener noreferrer">
     <div style={{backgroundColor:color}} className='image-link'>
    <img src={facebook} alt="Facebook logo" />
    </div>
    
    <span>Facebook</span>
    <span>{data.type}</span>
  </a>
))
}


{data.twiter.length > 0 &&
data.twiter.map((data, index) => (
  <a className='main-image-link' key={index} href={data.link}  rel="noopener noreferrer">
    
     <div style={{backgroundColor: color}} className='image-link'>
    <img src={Twiter} alt="Twiter logo" />
    </div>
    <span>X</span>
    <span>{data.type}</span>
  </a>
))
}
{data.linkedin.length > 0 &&
data.linkedin.map((data, index) => (
  <a className='main-image-link' key={index} href={data.link}  rel="noopener noreferrer">
     <div style={{backgroundColor: color}} className='image-link'>
    <img src={Linkedin} alt="Linkedin logo" />
    </div>
    <span>LinkedIn</span>
    <span>{data.type}</span>
  </a>
))
}
{data.instgram.length > 0 &&
data.instgram.map((data, index) => (
  <a className='main-image-link' key={index} href={data.link}  rel="noopener noreferrer">
     <div style={{backgroundColor: color}} className='image-link'>
    <img src={Instagram} alt="Instagram logo" />
    </div>
    <span>Instagram</span>
    <span>{data.type}</span>
  </a>
))
}
{data.snapChat.length > 0 &&
data.snapChat.map((data, index) => (
  <a className='main-image-link' key={index} href={data.link}  rel="noopener noreferrer">
     <div style={{backgroundColor: color}} className='image-link'>
    <img src={snap} alt="snap logo" />
    </div>
    <span>Snap</span>
    <span>{data.type}</span>
  </a>
))
}
{data.tikTok.length > 0 &&
data.tikTok.map((data, index) => (
  <a className='main-image-link' key={index} href={data.link}  rel="noopener noreferrer">
     <div style={{backgroundColor: color}} className='image-link'>
    <img src={tiktok} alt="tiktok logo" />
    </div>
    <span>Tik Tok</span>
    <span>{data.type}</span>
  </a>
))
}
{data.telegram?.length > 0 &&
data.telegram?.map((data, index) => (
  <a className='main-image-link' key={index} href={data.link}  rel="noopener noreferrer">
     <div style={{backgroundColor: color}} className='image-link'>
    <img src={Telegram} alt="telegram logo" />
    </div>
    <span>Telegram</span>
    <span>{data.type}</span>
  </a>
))
}
{data.weChat?.length > 0 &&
data.weChat?.map((data, index) => (
  <a className='main-image-link' key={index} href={data.link}  rel="noopener noreferrer">
     <div style={{backgroundColor: color}} className='image-link'>
    <img className='weChat-icon image-link' src={WeChat} alt="WeChat logo" />
    </div>
    <span>WeChat</span>
    <span>{data.type}</span>
  </a>
))
}
{data.googleRate?.length > 0 &&
data.googleRate?.map((data, index) => (
  <a className='main-image-link' key={index} href={data.link}  rel="noopener noreferrer">
     <div style={{backgroundColor: color}} className='image-link'>
      <div className='googleRate-class-icon'>
 <img src={GoogleRate} alt="GoogleRate logo" />
 <div className='googleRate-class-stars'>
<img src={Stars} alt="stars logo" />
<img src={Stars} alt="stars logo" />
<img src={Stars} alt="stars logo" />
<img src={Stars} alt="stars logo" />
<img src={Stars} alt="stars logo" />
 </div>
    
      </div>
      {/* <img src={Stars} alt="stars logo" /> */}
   
    

    </div>
    <span>Google Reviews</span>
    <span>{data.type}</span>
  </a>
))
}
{data.pintrest?.length > 0 &&
data.pintrest?.map((data, index) => (
  <a className='main-image-link' key={index} href={data.link}  rel="noopener noreferrer">
     <div style={{backgroundColor: color}} className='image-link'>
    <img src={Pintrest} alt="Pintrest logo" />
    </div>
    <span>Pinterest</span>
    <span>{data.type}</span>
  </a>
))
}
{data.youtube.length > 0 &&
data.youtube.map((data, index) => (
  <a className='main-image-link' key={index} href={data.link}  rel="noopener noreferrer">
     <div style={{backgroundColor: color}} className='image-link'>
    <img src={youtube} alt="youtube logo" />
    </div>
    <span>YouTube</span>
    <span>{data.type}</span>
  </a>
))
}
{data.website.length > 0 &&
data.website.map((data, index) => (
  <a className='main-image-link' key={index} href={data.link}  rel="noopener noreferrer">
    <div style={{backgroundColor: color}} className='image-link'>
    <img src={link} alt="link logo" />
    </div>
    <span>Website</span>
    <span>{data.type}</span>
  </a>
))
}

{data.location.length > 0 &&
data.location.map((data, index) => (
  <a className='main-image-link' key={index} href={data.link}  rel="noopener noreferrer">
     <div style={{backgroundColor: color}} className='image-link'>
    <img src={Location} alt="Location logo" />
    </div>
    <span>Location</span>
    <span>{data.type}</span>
  </a>
))
}
{data?.link?.length > 0 &&
data.link.map((data, index) => (
  <a className='main-image-link' key={index} href={data.link}  rel="noopener noreferrer">
     <div style={{backgroundColor: color}} className='image-link'>
    <img style={{width: '44px'}} src={link2} alt="Location logo" />
    </div>
    {/* <span>Location</span> */}
    <span>{data.type}</span>
  </a>
))
}
{/* <a>
<img src={Location}  alt="Location logo" />
</a> */}
{/* <a>
<img src={telegram}  alt="telegram logo" />
</a> */}
    </div>
    {data.pdf?.length > 0 &&
    <div className='main-pdf-link'>
    {data.pdf?.length > 0 &&
   data.pdf.map((data, index) => (
  <a className='' key={index} href={`${data.link}`}  rel="noopener noreferrer">
    <div className='d-flex pdf-link'>
    <div style={{backgroundColor: color}} className='image-link'>
    <img src={Pdf} alt="Email logo" />
    </div>
    <p  style={{color: color ,fontSize:16 ,fontWeight:500}}>{data.type}</p>
    </div>
  </a>
))
}
</div>
}
{data.menuLink &&

<a className='' target='_blank' href={`${data.menuLink}`} style={{marginTop: '25px' ,textDecoration: 'none'}}  rel="noopener noreferrer">
<div className='d-flex pdf-link'>
<div style={{backgroundColor: color}} className='image-link'>
<RestaurantMenu sx={{ fontSize: 44 ,color: '#fff' }} />
</div>
<p  style={{color: color ,fontSize:16 ,fontWeight:500}}>Show Menu</p>
</div>
</a>
}

    {data.orderImages?.length > 0 &&
    <div className='gellary-of-user'>
      {/* <h2>
Gellary
      </h2> */}
    <MuiImageSlider className='gellary-of-user' images={data.orderImages} />
    </div>
    }
    </div>
    <SaveContac color={color} data={data} />
    <div style={{ backgroundImage}} className='footer'>
      <p>Soon the biggest network's opporient in the Middle East</p>
      
    </div>
  </div>
  )}
  </>}
  </>
  }
  </>
  
    );
}
export default UserProfile;
